import { createSlice } from '@reduxjs/toolkit'
import produce from 'immer'

import { layoutInitial as initialState } from '../store-initial-state'

const layoutSlice = createSlice({
    name: 'layoutSlice',
    initialState,
    reducers: {
        setLayout: produce((state, action) => {
            Object.assign(state, action.payload)
        }),
    },
})

export const { setLayout } = layoutSlice.actions
export default layoutSlice.reducer
